<app-kontable
        #table
        id="dt_classification"
        title = "{{ 'common.classification_title' | translate }}"
        [columns] = "[
            'id',
            'parentName',
            'name',
            { field: 'classification_type', title: 'common.type', bodyTemplate: valueTypeName, filterType: customFilter }
        ]"
        [titles] = "['common.id', 'common.parent_name', 'common.classification_name']"
        [showInfoButton]="false"
        [showRecoverButton]="false"
        [showGlobalFilter]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [additionalRowCommands]="customRow"
        [(fireNewDataAvailable)]="newDataAvailable"
        [source]="svc.list"
        (onAdd)="showAddOrEditDialog($event)"
        (onEdit)="showAddOrEditDialog($event)"
        (onRemove)="delete($event)">


    <ng-template #valueTypeName data-testid="valueTypeName" let-row>{{row.classification_type?.name}}</ng-template>

    <ng-template #customRow data-testid="customRow" let-row>
        <p-button label="" pTooltip="{{ 'common.details' | translate }}" icon="fa fas fa-hashtag" styleClass="ui-button-info" (onClick)="customButtonClick(row)"></p-button>
    </ng-template>

</app-kontable>

<p-dialog
        *ngIf="svc.editing"
        header="{{modalTitle}}"
        [width]="600"
        [(visible)]="svc.editing"
        [responsive]="true"
        showEffect="fade"
        [modal]="true"
        (onHide)="onDialogHide()">
    <app-common-classification-form
            [editingElement]="svc.editing"
            (onAddElement)="onAddElement($event)"
            (onUpdateElement)="onUpdateElement($event)">
    </app-common-classification-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/classification/classification-list/classification-list.component.html